module.exports = __webpack_public_path__ + "img/1.80af1a92.jpg";